var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('st-data-table',{attrs:{"items":_vm.rows,"fields":_vm.fields,"actions":_vm.actions,"modelPresenter":_vm.presenter,"responsive":"sm","hover":""},on:{"edit":_vm.onEdit,"delete":_vm.onDelete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }